// =============================================================================
// _facility-enum.ts — case-insensitive FacilityCategory / FacilityType parsing.
//
// Unity uses Enum.TryParse(..., true, ...) — ignoreCase=true. Web port mirrors
// this via tryParseEnumIgnoreCase against canonical value arrays.
//
// Shared by:
//   • effects/effect-kind-resolver-registry.ts (resolver-side, AuraApply +
//     BuildCostMod parsing)
//   • services/build-cost-service.ts (hand-scan / applicableHandDiscounts)
//
// Cross-group sweep (E1 R2 Low → WEB.2.1): hand-scan parser was case-sensitive
// before this file existed; resolver path was already case-insensitive after
// E1 R2. Sharing the helper closes that drift.
// =============================================================================

import type { FacilityCategory, FacilityType } from "@gdg/shared";

export const FACILITY_CATEGORY_VALUES: ReadonlyArray<FacilityCategory> = Object.freeze([
  "Fossil",
  "Renewable",
  "Nuclear",
  "Geothermal",
  "Waste",
]);

export const FACILITY_TYPE_VALUES: ReadonlyArray<FacilityType> = Object.freeze([
  "Coal",
  "Hydro",
  "Biomass",
  "Oil",
  "OffshoreDrilling",
  "WasteToEnergy",
  "Geothermal",
  "Nuclear",
  "Wind",
  "Solar",
  "FloatingSolar",
  "Tidal",
]);

/**
 * Case-insensitive enum parse. Returns the canonical value (with original casing
 * from `values`) or null. Mirrors Unity Enum.TryParse(..., true, ...).
 */
export function tryParseEnumIgnoreCase<T extends string>(
  raw: string,
  values: ReadonlyArray<T>,
): T | null {
  const lower = raw.toLowerCase();
  for (const v of values) {
    if (v.toLowerCase() === lower) return v;
  }
  return null;
}
